import {
  Category,
  DataLayerEntry,
  EventInfo,
  PageAttributes,
  UserProfileInfo,
} from "./types";

export function setPageAttributes(obj: DataLayerEntry, value: PageAttributes) {
  if (!obj.page) obj.page = {};
  obj.page.attributes = value;
}

export function setUserProfileInfo(
  obj: DataLayerEntry,
  value: UserProfileInfo,
) {
  if (!obj.user) obj.user = [];
  if (!obj.user[0].profile) obj.user[0].profile = [];
  if (!obj.user[0].profile[0].profileInfo)
    obj.user[0].profile[0].profileInfo = {};
  obj.user[0].profile[0].profileInfo = {
    ...obj.user[0].profile[0].profileInfo,
    ...value,
  };
}

export function setEventInfo(obj: DataLayerEntry, value: EventInfo) {
  if (!obj.event) obj.event = {};
  if (!obj.event.eventInfo) obj.event.eventInfo = {};
  obj.event.eventInfo = { ...obj.event.eventInfo, ...value };
}

export function setEventCategory(obj: DataLayerEntry, value: Category) {
  if (!obj.event) obj.event = {};
  if (!obj.event.category) obj.event.category = {};
  obj.event.category = { ...obj.event.category, ...value };
}
